import React from "react";
import { ArrowRight, Expand } from "lucide-react";
import { STYLES } from "../mock";
import Reveal from "./Reveal";

export default function StyleGallery({ onChoose, onPreview }) {
  return (
    <section id="estilos" className="py-20 md:py-32 bg-[#f5f1e8] border-t border-[#e8ddc3]/60">
      <div className="max-w-7xl mx-auto px-6">
        <Reveal className="text-center mb-14 md:mb-20">
          <div className="text-[11px] md:text-xs tracking-[0.25em] uppercase text-[#b59557] mb-4">
            Colección
          </div>
          <h2 className="font-serif font-medium text-[#1a1816] text-3xl md:text-5xl leading-tight">
            Elige tu{" "}
            <span className="italic text-[#b59557] font-light">estilo</span>
          </h2>
          <p className="mt-4 text-[#4a4136] text-sm md:text-base max-w-2xl mx-auto">
            Cada estilo está cuidadosamente diseñado para resaltar la personalidad única de tu mascota
            en un formato artístico exclusivo. Haz clic en la imagen para verla a tamaño completo.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {STYLES.map((s, idx) => (
            <Reveal
              key={s.id}
              delay={(idx % 3) + 1}
              as="article"
              className="style-card group text-left bg-white rounded-[22px] overflow-hidden border border-[#ece3cc] shadow-sm"
            >
              <button
                type="button"
                onClick={() => onPreview(s)}
                data-testid={`style-preview-open-${s.id}`}
                className="relative block w-full aspect-[4/3] overflow-hidden bg-[#f0e8d3] focus:outline-none focus:ring-2 focus:ring-[#b59557]"
                aria-label={`Ver ejemplo del estilo ${s.name}`}
              >
                <img
                  src={s.image}
                  alt={s.name}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.04]"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-[#1a1816]/0 group-hover:bg-[#1a1816]/25 transition-colors duration-300 flex items-center justify-center">
                  <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 translate-y-2 group-hover:translate-y-0 inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/95 text-[#1a1816] text-sm font-medium shadow-lg">
                    <Expand className="h-4 w-4 text-[#b59557]" />
                    Ver ejemplo
                  </div>
                </div>
              </button>

              <div className="p-6 md:p-7">
                <h3 className="font-serif text-xl md:text-2xl text-[#1a1816]">{s.name}</h3>
                <p className="mt-2 text-sm text-[#4a4136] leading-relaxed line-clamp-3">
                  {s.description}
                </p>
                <div className="mt-6 flex items-center justify-between">
                  <span className="font-serif italic text-lg md:text-xl text-[#8a7340]">
                    {s.price}
                  </span>
                  <button
                    type="button"
                    onClick={() => onChoose(s)}
                    data-testid={`style-choose-${s.id}`}
                    className="group/btn inline-flex items-center gap-2 text-sm text-[#1a1816] hover:text-[#b59557] transition-colors"
                  >
                    Elegir
                    <ArrowRight className="h-4 w-4 transition-transform group-hover/btn:translate-x-1" />
                  </button>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
